import { useMutation } from '@tanstack/react-query';

import { RECORDING_API } from '@/shared/api/recording';

export const useShareRecording = () => {
  return useMutation({
    mutationFn: RECORDING_API.shareRecording,
    retry: (failureCount, error) => {
      const apiError = error as { status?: number };

      if (apiError.status && apiError.status >= 400 && apiError.status < 500) return false;

      return failureCount < 3;
    },
  });
};
